import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_DONGTIENNHANH } from "actions/DongTienNhanh/actionTypes";
import {
  getListDongTienNhanhSuccess,
  getListDongTienNhanhFailure,
} from "actions/DongTienNhanh";
import DongTienNhanhApi from "service/traGopApi";
import { pushNotification } from "utils/notifications";

function* getListDongTienNhanh(action) {
  try {
    const response = yield call(DongTienNhanhApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListDongTienNhanhSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListDongTienNhanhFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListDongTienNhanhFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_DONGTIENNHANH, getListDongTienNhanh);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
